import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  NgZone,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { FiledownloadComponent } from "src/app/shared/common/filedownload.component";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from "@angular/animations";
import {
  DragDropModule,
  CdkDragDrop,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import { take } from "rxjs";
import { ActionCheckBox } from "src/app/shared/common/ActionCheckBox";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { constants } from "src/app/shared/common/contants";
import { CustomCheckButton } from "src/app/shared/common/Checkbutton";
import { ColumnsDialogComponent } from "./columns-dialog/columns-dialog.component";
import { MatFormField } from "@angular/material/form-field";
import { MatStepper } from "@angular/material/stepper";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { IncrementalDataLoadSchedulePopupComponent } from "../../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component";
import { IncrDataLoadScheduleService } from "src/app/shared/services/incr-data-load-schedule.service";
import { MatExpansionPanel } from "@angular/material/expansion";

interface Product {
  id: string;
  name: string;
}
interface DocumentControl {
  name: string;
  version: string | null;
  CreatedDate: string | null;
  author: string | null;
  reviewers: string;
  approver: string;
  approvedDate: string;
  status: string;
  renewalPeriodSchedulerId:any;
  level:String;
}
export interface ProductOverview {
  activeSubstance?: string;
  productType?: string;
  indications?: string;
  developmentPhase?: string;
  regionsMarkets?: string;
  // …you can add more dynamic props here…
}
interface Lookup {
  lookupvalue: string;
}
interface ProductMeta {
  id?: string;
  status?: string;
  dibd?: string | null; // DIBD
  ibd?: string | null; // IBD
  safetyTitle?: string;
  safetyStrategyLink?: string;
  producttype?: string;
   productName?: string;
}
@Component({
    selector: "app-product-safety-strategy",
    templateUrl: "./product-safety-strategy.component.html",
    styleUrls: ["./product-safety-strategy.component.scss"],
    animations: [
        trigger("pageFlip", [
            // no special styling for init state
            state("none", style({ transform: "none" })),
            // Next: page swings in from right (Y axis +90° → 0°)
            transition("* => next", [
                style({ transform: "rotateY(90deg)" }),
                animate("800ms ease-out", style({ transform: "rotateY(0)" })),
            ]),
            // Prev: page swings in from left (Y axis -90° → 0°)
            transition("* => prev", [
                style({ transform: "rotateY(-90deg)" }),
                animate("800ms ease-out", style({ transform: "rotateY(0)" })),
            ]),
            // reset back to none so the next flip can happen
            transition("next => none, prev => none", [animate("0ms")]),
        ]),
    ],
    standalone: false
})
export class ProductSafetyStrategyComponent implements OnInit {
  productDocumentControls: Record<string, DocumentControl> = {};
  productOverviews: Record<string, ProductOverview> = {};
  @ViewChild("templateDialog") templateDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("strategyNameField", { read: MatFormField })
  strategyNameField?: MatFormField;
  @ViewChild("stepper") matStepper?: MatStepper;
  templateId = "";
  workflowForm: FormGroup;
  selectedActivities: string[] = [];
  step = 1;
  stepOneFormGroup: FormGroup;
  stepTwoFormGroup: FormGroup;
  previewData: any[] = [];
  productSearchText: string = "";
  activitySearchText: string = "";
  backgroundColorScreen = "";
  backgroundColorButton = "";
  isDownloading = false;

  activityOptions: any;

  productOptions = [];
  reviewPeriods = ["Weekly", "Monthly", "Quarterly", "HalfYearly", "Yearly"] as const;
  roles: any;
  filteredProducts: typeof this.productOptions = [];
  filteredActivities: { lookupvalue: string }[] = [];
  paginationPageSize: any;
  paginationNumberFormatter: any;
  components: any;
  gridAPI: any;
  gridColumnAPI: any;
  gridmgrnAPI: any;
  RunpageSize = 10;
  value: any;
  RuncurrentPage;
  RuntotalPages;
  RunlastPage;
  RunnextPage;
  RunnextPagePlusOne;
  selectedProducts: string[] = [];
  showWorkflow = false;
  currentProductPage = 0;
  pageSize = 1;
  selectedProduct: any;
  strategytemplate: any;
  SignalSources: any;
  // 1) grid size and hover state
  tableGrid = Array(5).fill(0); // 5x5 max
  tableRows = 0;
  tableCols = 0;
  optionsMap: { [key: string]: any[] } = {};
  showDocumentSections = false;

  //keys are lookuptype , assignTo :-  are property to which lookup need to be added
  lookups = [
    { key: "activityOptions", assignTo: "activityOptions" },
    { key: "RolesAllowed", assignTo: "roles" },
    { key: "SignalSources", assignTo: "SignalSources" },
    { key: "StrategyTemplates", assignTo: "strategytemplate" },
    { key: "ActivityLevel", assignTo: "levels" },
  ];

  // form inside modal
  templateForm: FormGroup = this.fb.group({
    templateId: [null, Validators.required],
    products: [[], Validators.required],
    selectedProduct: [null],
  });
  selectedProductsFromDialog: string[] = [];
  showGrid: any;
  ProductJson = {};

  rowData: any;
  isEditMode = false;
  editJson: any = null;

  selectedTemplateId: any;
  selectedSections: any[];
  objectKeys = Object.keys;
  // keep track of flip direction
  flipState: "none" | "next" | "prev" = "none";
  productsWithJson: string[] = [];
  templateStructures: { [key: string]: any[] } = {};
  levels: any;
  // AG-Grid defaults
  defaultColDef;
  columnDefs;
  // if the record has status==no , row color will change
  rowClassRules;
  getRowStyle = (params: any) => {
    console.log(params);
    console.log(params.data.status);
    if (params.data.status === "No") {
      return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
    }
    // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
  };
  allColumns ;
  toggleableCols: Array<{ headerName: string; field: string }> = [];
  selectedFields: string[] = []; // currently visible fields (for the mat-select)
  showLatestOnly: boolean = true;
  gridRowData = [];
  productStrategyData=[];
  productName: any;
  productStrategyIdToEdit: any | null = null;
  deleteStrategy: any;
  productJsonMap: Record<string, any> = {}; // key: productId → parsed JSON
  loading = false;
  showCreateTemplate = false;
  cancelManually = false;
  templates: any[];
  templateName: string;
  selectedRows = [];
  rowDataForEdit: any;
  ProductStrategyJson: any;
  docVersion: string;
  ModifiedJSonInEdit: any;
  currentSectionId: string;
  sectionId: any;
  userRole: string;
  isPreview: boolean;
  commentCountMap: { [sectionId: string]: number } = {};
  autoSaveTimer: any;
  ProductID: any;
  allComments: any[] = [];
  isFirstLoad: boolean = true;
  reviewRefreshInterval: any;
  //state to store the PSS State From the grid
  state: string;
  pssId: any;
  selectedTemplateJson: any;
  Accesstypes: any =[];
  minDate: Date;
  //below  currentData stores the orginal json loaded at Edit() before editing  
  currentData: any;
  // this stores the hash for the orginaljson loaded at fetchLatestJson() before editing  
  originalHash: string | null = null;
  fileName: string;
selectSchedule: any;
scheduleid:any
uniquenumber:Number;
productIdMap = new Map<string, number>();
maxVisibleChips = 5;
panelOpenState=true;
showProductInfoPage=false;
productMeta:ProductMeta
selectedProductIdFromGridToShowInfo:any;

  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private constants: constants,
    private jsignalsService: JsignalService,
    private service: ReportingServiceService,
    private validate: validationmethod,
    private secheduleService: IncrDataLoadScheduleService,
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
      headerRenderer: CustomCheckButton,
    };

    this.stepOneFormGroup = this.fb.group({
      templateName: ["", Validators.required],
      description: [""],
      activities: [[]],
      reviewPeriod: ["Monthly"],
      dueDays: [1],
      strategyReviewPeriod: [""],
      // number: [null, [Validators.min(0)]],
      // period: ["months"],
      // startDate: [null],
      sections: this.fb.array([]),
      // NEW: PSS review & approval fields (defaults to 7 Days)
      pssReviewNumber: [7, [Validators.min(0)]],
      pssReviewPeriod: ["Days"],
      pssApprovalNumber: [7, [Validators.min(0)]],
      pssApprovalPeriod: ["Days"],
      selectschedule:["",Validators.required],
      level: ["", Validators.required],
    });

    this.stepTwoFormGroup = this.fb.group({
      activityConfigs: this.fb.array([]),
      evidenceRequired: [""],
      uploadInstructions: [""],
      // rolesAllowed: [""],
      level: [""],
      activitydescripition: ['',this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore] 
    });
  }

  ngOnInit(): void {
   const state = history.state;
   console.log(state);
   this.productMeta=state?.productMetaData
  //  const data = sessionStorage.getItem('productMetaData');
  // this.productMeta = data ? JSON.parse(data) : null;
  // console.log(this.productMeta);
  // console.log(this.productMeta.productName);
  // if(this.productMeta){
  //    this.showProductInfoPage=true;
  // }else{
  //   this.showProductInfoPage=false;
  // }
    this.defaultColDef =   { sortable: true, resizable: true, filter: true,
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      } }; 
    this.columnDefs =  [
    {
      headerName: "Action",
      filter: false,
      cellRenderer: "jsignalButton",
      pinned: "left",
      lockPinned: true,
      headerTooltip: "Action",
      headerComponent: "headerRenderer",
      headerComponentParams: {
        updateCheckbox: this.onHeaderCheckboxChange.bind(this),
      },
      cellRendererParams: (params: any) => ({
        //below value is passed to button to hide check box for deleted rows
       disableCheckBox: params.data?.status === "No",
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
        onCheckboxChange: this.checkboxIcon.bind(this),
        onPreview: this.previewFile.bind(this),
        onRegenerateDocument: this.onRegenerateDocument.bind(this),
      }),
      width: 250,
      hide: false,
    },

    {
      headerName: "PSS Name",
      field: "productStrategyName",
      filter: "agTextColumnFilter",
      headerTooltip: "PSS Name",
      tooltipValueGetter: (params) => "PSS Name : " + params.value,
      hide: false,
      width: 250,
    },
    {
          headerName: "Product Name",
          field: "productName",
          filter: "agTextColumnFilter",
           cellRenderer: "jsignalButton",
          headerTooltip: "Product Name",
          tooltipValueGetter: (params) => "Product Name : " + params.value,
          hide: false,
          width: 200,
           cellRendererParams: (params: any) => ({
        normalLink: this.getProductInfoPage.bind(this)
      })
        },
    // {
    //   headerName: "Product Name",
    //   field: "productName",
    //   filter: "agTextColumnFilter",
    //   headerTooltip: "Product Name",
    //   tooltipValueGetter: (params) => "Product Name : " + params.value,
    //   hide: false,
    //   width: 200,
    // },
    {
      headerName: "Product State",
      field: "productState",
      filter: "agTextColumnFilter",
      headerTooltip: "Product State",
        tooltipValueGetter: (params) => {
        const value = params.value;
        if (value === "active__v") return "Product State : Active";
        if (value === "inactive__v") return "Product State : Inactive";
        return "Product State : " + (value || "");
      },
      hide: false,
      width: 180,

      //Custom cell renderer for colored label
      cellRenderer: (params) => {
        const value = params.value;
        if (value === "active__v") {
          return `<span style="color: green; font-weight: 600;">Active</span>`;
        }
        return `<span>${value || ""}</span>`;
      },

      // Optional: make sure raw value (not HTML) is used for filtering/sorting
      cellRendererParams: { suppressHtmlEscaping: false },
    },
    {
      headerName: "Version",
      field: "version",
      filter: "agTextColumnFilter",
      headerTooltip: "Version",
      tooltipValueGetter: (params) => "Version : " + params.value,
      hide: false,
      width: 100,
    },
    {
      headerName: "Reviewer ",
      field: "reviewerName",
      filter: "agTextColumnFilter",
     headerTooltip: "Reviewer",
      tooltipValueGetter: (params) => "Reviewer : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Approver ",
      field: "approverName",
      filter: "agTextColumnFilter",
      headerTooltip: "Approver",
      tooltipValueGetter: (params) => "Approver : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "State",
      field: "state",
     headerTooltip: "State",
      filter: "agTextColumnFilter",
      tooltipValueGetter: (params) => "State : " + params.value,
      width: 160,
      cellRenderer: (params: any) => {
        const state = params.data.state; // display text
        const stateCode = params.data.stateCode; // color based on this
        let badgeClass = "";

        // Map stateCode to badge classes
        switch (stateCode) {
          case "1":
            badgeClass = "state-badge draft";
            break;
          case "2":
            badgeClass = "state-badge review";
            break;
          case "3":
            badgeClass = "state-badge approval";
            break;
          case "4":
            badgeClass = "state-badge approved";
            break;
          case "5":
            badgeClass = "state-badge superseded";
            break;
          default:
            badgeClass = "state-badge default";
        }

        return `
      <span class="${badgeClass}">
        <span class="dot"></span>${state}
      </span>`;
      },
    },
    {
      headerName: "Author ",
      field: "author",
      filter: "agTextColumnFilter",
      headerTooltip: "Author",
      tooltipValueGetter: (params) => "Author : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      filter: "agTextColumnFilter",
      headerTooltip: "Created By",
      tooltipValueGetter: (params) => "Created By : " + params.value,
      hide: true,
      width: 180,
    },
    // {
    //   headerName: "Comments",
    //   field: "comments",
    //   flex: 2,
    //   cellClass: "ag-cell-flash",
    //   cellRenderer: (params) => {
    //     const val = params.value;
    //     if (!val) return "";

    //     if (typeof val === "object") {
    //       return Object.entries(val)
    //         .map(([role, msgs]) => {
    //           if (Array.isArray(msgs)) {
    //             return `${role}: ${msgs.join("; ")}`;
    //           } else {
    //             return `${role}: ${msgs}`;
    //           }
    //         })
    //         .join(" | ");
    //     }
    //     return val;
    //   },
    //   tooltipValueGetter: (params) => {
    //     const val = params.value;
    //     if (!val) return "";
    //     if (typeof val === "object") {
    //       return Object.entries(val)
    //         .map(([role, msgs]) => {
    //           if (Array.isArray(msgs)) {
    //             return `${role}:\n - ${msgs.join("\n - ")}`;
    //           } else {
    //             return `${role}: ${msgs}`;
    //           }
    //         })
    //         .join("\n");
    //     }
    //     return val;
    //   },
    //   width: 180,
    //   hide: true,
    // },
    {
      headerName: "Download",
      headerTooltip: "Download",
      cellRenderer: "jsignalButton",
      cellRendererParams: {
        onWord: this.downloadWord.bind(this),
        onPdf: this.downloadPdf.bind(this),
      },
      hide: false,
      width: 150,
    },
     {
      headerName: "Document Generation Status",
      field: "wordDocGenerationStatus",
      filter: "agTextColumnFilter",
      headerTooltip: "Document Generation Status",
      tooltipValueGetter: (params) => "Document Generation Status : " + params.value,
      hide: false,
      width: 180,
    },
    {
      headerName: "Remarks",
      field: "remarks",
      filter: "agTextColumnFilter",
      headerTooltip: "Remarks",
      tooltipValueGetter: (params) => "Remarks :"  + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Activity Name",
      field: "activityname",
      filter: "agTextColumnFilter",
      headerTooltip: "Activity Name",
      tooltipValueGetter: (params) => "Activity Name : " + params.value,
      hide: true,
      width: 230,
    },
    {
      headerName: "Template Name",
      field: "templateName",
      filter: "agTextColumnFilter",
      headerTooltip: "Template Name",
      tooltipValueGetter: (params) => "Template Name : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Start Date",
      field: "createdDate",
      filter: "agTextColumnFilter",
      headerTooltip: "Start Date",
      tooltipValueGetter: (params) => "Start Date : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Due Date",
      field: "duedate",
      filter: "agTextColumnFilter",
      headerTooltip: "Due Date",
      tooltipValueGetter: (params) => "Due Date : " + params.value,
      hide: true,
      width: 180,
    },
    // {
    //   headerName: "End Date",
    //   field: "enddate",
    //   filter: "agNumberColumnFilter",
    //   headerTooltip: "End Date",
    //   tooltipValueGetter: (params) => "End Date : " + params.value,
    //   hide: true,
    //   width: 180,
    // },
    {
      headerName: "Last Modified By",
      field: "lastModifiedBy",
      filter: "agTextColumnFilter",
      headerTooltip: "Last Modified By",
      tooltipValueGetter: (params) => "Last Modified By : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "Last Modified Date",
      field: "lastModifiedDate",
      filter: "agTextColumnFilter",
      headerTooltip: "Last Modified Date",
      tooltipValueGetter: (params) => "Last Modified Date : " + params.value,
      hide: true,
      width: 180,
    },
    {
      headerName: "is_Latest",
      field: "is_Latest",
      filter: "agSetColumnFilter",
      headerTooltip: "is_Latest",
      tooltipValueGetter: (params) => "is_Latest : " + params.value,
      hide: true,
      width: 80,
    }, // Is_latest filter
  ];
    this.rowClassRules =    {
    sick: function (params) {
      var numSickDays = params.node.data.status;
      return numSickDays === "No" || numSickDays === null;
    },
  };
    this.allColumns = this.columnDefs;
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");

    // this.filteredProducts = [...this.productOptions];

    // Fetch all lookups (To add new lookup Mention In lookups[]  )
    this.lookups.forEach((lookup) => {
      this.commonService.getlookupVauleByLookUpType(lookup.key).subscribe({
        next: (result: any) => {
          console.log(`Lookup "${lookup.key}" (${lookup.assignTo}):`, result);
          // assign every lookup to its target property
          (this as any)[lookup.assignTo] = result;

          // only seed filteredActivities when activityOptions arrives
          if (lookup.assignTo === "activityOptions") {
            if (Array.isArray(result)) {
              this.filteredActivities = result.map((r: any) => ({
                lookupvalue: r.lookupvalue,
              })); //  result becomes Lookup[]
            } else {
              console.warn(
                `Expected activityOptions to be an array, got:`,
                result
              );
              this.filteredActivities = [];
            }
          }
        },
        error: (err) => {
          console.error(`Error loading lookup "${lookup.key}":`, err);
        },
      });
    });

    //fetch product name
    /**
   * @Modified Rahul Vk
   * @Date 14-11-2025
   * @Desc fetch the list of product[{id:,name:}]
   */   
    this.jsignalsService.getProductList().subscribe({
  next: (rows: Product[]) => {
    // Map the response directly
    this.productOptions = rows.map(r => ({ id: r.id, name: r.name }));

    // Initialize filtered list
    this.filteredProducts = [...this.productOptions];

    // Optional default selection
    this.selectedProduct = this.productOptions[0] || null;

    // Build lookup map: productName → productId
    this.productIdMap = new Map(this.productOptions.map(p => [p.name, p.id]));

    console.log('Loaded products:', this.productOptions);
  },
  error: (err) => console.error('Error loading products:', err),
});


    //All product strategies
    // this.loadGridData(); // refresh grid

    // this.productsWithJson = [ this.ProductJson.productName ];
    // this.templateForm.get('selectionType')?.setValue('existing');
    // this.cdr.detectChanges();

    //fetch all templates
    this.jsignalsService
      .getAllTemplates()
      .subscribe((list) => (this.templates = list));
    console.log(this.templates);

    this.Useroles();
    this.minDate = new Date(); // sets today as the minimum selectable date
    this.loadGridData();

  }
togglePanel(event: MouseEvent, panel: MatExpansionPanel): void {
  event.stopPropagation(); // prevent header default toggle
  panel.toggle();
}
  get stepTwoFormArray(): FormArray {
    return this.stepTwoFormGroup.get("activityConfigs") as FormArray;
  }

  get activityControls() {
    return this.stepTwoFormArray.controls;
  }
  get stepOneSections(): FormArray {
    return this.stepOneFormGroup.get("sections") as FormArray;
  }

  // All other header buttons: do action only, no toggle
onCreateTemplate(event: MouseEvent): void {
  event.stopPropagation();
  this.onAdd();
}

onDownloadHistory(event: MouseEvent): void {
  event.stopPropagation();
  this.onDownloadhistory();
}

onRefresh(event: MouseEvent): void {
  event.stopPropagation();
  this.onrefresh();
}
onDownloadWord(event: MouseEvent): void {
  event.stopPropagation();
  this.downloadSelectedStrategies();
}
onCompare(event: MouseEvent): void {
  event.stopPropagation();
  this.compareSelectedStrategies();
}
  onReset() {
    this.workflowForm.reset({
      reviewPeriod: "Monthly",
      dueDays: 7,
      evidenceRequired: "Yes",
      allowedFileTypes: ".pdf, .docx, .jpg, .xlsx",
      maxSize: 10,
      productRequired: true,
    });
  }

  // @note :- below function builds the next page page formgroup i.e stepTwoFormGroup

  goToStepTwo(stepper: any) {
    if (this.stepOneFormGroup.invalid){
     this.stepOneFormGroup.markAllAsTouched(); 
    return;  
    } 

    const selectedLevel = this.stepOneFormGroup.get("level")?.value;

    const periodMap: Record<string, number> = {
      Weekly: 7,
      Monthly: 30,
      Quarterly: 90,
      Yearly: 365,
      HalfYearly: 180
    };

    this.stepTwoFormArray.clear();
    this.selectedActivities = this.stepOneFormGroup.value
      .activities as string[];

    this.selectedActivities.forEach((activity) => {
      const defaultPeriod = "Monthly";
      const defaultDays = periodMap[defaultPeriod];

      const grp = this.fb.group({
        activity: [activity],
        level: [selectedLevel, Validators.required], //Autofilled + readonly
        reviewPeriod: [defaultPeriod, Validators.required],
        dueDays: [defaultDays, [Validators.required, Validators.min(1)]],
        // originalReviewPeriod: [defaultPeriod],
        // originalDueDays: [defaultDays],
        // ─── DURATION H:M:S ───
        durationHours: [1, [Validators.required, Validators.min(1)]],
        // durationMinutes: [0],
        // durationSeconds: [0],
        evidenceRequired: ["Yes"],
        uploadInstructions: [""],
        // rolesAllowed: ["", Validators.required],
        startDate: [null, Validators.required],
        // Added By Rahul Vk 
        activitydescripition: ['',this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore] 
      });

      let manuallyEdited = false;

      // Detect manual edit
      grp.get("dueDays")!.valueChanges.subscribe(() => {
        manuallyEdited = true;
      });

      // Only update dueDays if user hasn't manually overridden it
      grp.get("reviewPeriod")!.valueChanges.subscribe((rp: string) => {
        if (!manuallyEdited) {
          const newDue = periodMap[rp] ?? 0;
          grp.patchValue(
            {
              dueDays: newDue,
              // originalReviewPeriod: rp,
              // originalDueDays: newDue,
            },
            { emitEvent: false }
          );
        }
      });

      this.stepTwoFormArray.push(grp);
    });

    stepper.next();
  }

  goToStepThree(stepper: any) {

    console.log(this.stepTwoFormArray.controls);
    this.stepTwoFormGroup.markAllAsTouched();

    if (this.stepTwoFormGroup.invalid) return;
    console.log("stepOneFormGroup.value =", this.stepOneFormGroup.value);

    const activityDetails = this.stepTwoFormArray.value;

    // ⬇ Get Step 1 form values
    const templateName = this.stepOneFormGroup.get("templateName")?.value || "";
    const sections = this.stepOneFormGroup.get("sections")?.value || [];
    // If editing, parse doc controls from stored rowData
    const existingDocControls =
      this.isEditMode && this.rowDataForEdit
        ? this.extractDocControlsFromRowData(this.rowDataForEdit)
        : {};
    console.log("TempName", templateName);

    this.jsignalsService
      .getProductMetadata(this.selectedProductsFromDialog)
      .subscribe(
        (rawArr) => {
          if (!Array.isArray(rawArr)) {
            console.error("Product metadata response is not an array:", rawArr);
            this.previewData = this.selectedProductsFromDialog.map(
              (productName) => ({
                product: productName,
                doc: {},
                productOverview: {},
                templateName,
                sections,
                activityDetails,
              })
            );
            this.currentProductPage = 0;
            stepper.next();
            return;
          }

          this.productDocumentControls = {};
          this.productOverviews = {};

          this.selectedProductsFromDialog.forEach((prodName) => {
            let matchedKey: string | undefined;

            if (this.isEditMode && existingDocControls) {
              matchedKey = Object.keys(existingDocControls).find(
                (k) => k?.trim().toLowerCase() === prodName.trim().toLowerCase()
              );
            }

            if (matchedKey) {
              this.productDocumentControls[prodName] =
                existingDocControls[matchedKey];
            } else {
              this.productDocumentControls[prodName] =
                this.buildDocControlSkeleton(prodName);
            }
          });

          rawArr.forEach((raw) => {
            const name = raw.product__v_name__v?.trim() || "";
            if (!name) return;

            this.productOverviews[name] = {
              activeSubstance: raw.generic_name__v || "",
              productType: raw.product_type__v_name__v || "",
              indications: raw.indications__v || "",
              developmentPhase: raw.development_phase__v || "",
              regionsMarkets: raw.regions_markets__v || "",
            };
          });

          this.previewData = this.selectedProductsFromDialog.map(
            (productName) => ({
              product: productName,
              doc: this.productDocumentControls[productName] || {},
              productOverview: this.productOverviews[productName] || {},
              templateName,
              sections,
              activityDetails,
            })
          );

          this.currentProductPage = 0;
          stepper.next();
        },
        (error) => {
          console.error("Error fetching product metadata:", error);
          this.previewData = this.selectedProductsFromDialog.map(
            (productName) => ({
              product: productName,
              doc: {},
              productOverview: {},
              templateName,
              sections,
              activityDetails,
            })
          );
          this.currentProductPage = 0;
          stepper.next();
        }
      );
  }

  submitFinalForm(): void {
    this.SubmitStrategy("SUBMIT");
    // this.resetFormState();
  }

  // SubmitStrategy(state: string){

  // this.spinner.start();
  // const dnsName = this.localStorage.getSettings("dnsName");
  // const workspaceId = this.localStorage.getSettings("WorkspaceId");
  // const StrategyName = this.stepOneFormGroup.get('templateName')?.value ?? '';
  // // read PSS values from the stepOneFormGroup once
  // const pssReviewNumber = this.stepOneFormGroup.get('pssReviewNumber')?.value;
  // const pssReviewPeriod = this.stepOneFormGroup.get('pssReviewPeriod')?.value;
  // const pssApprovalNumber = this.stepOneFormGroup.get('pssApprovalNumber')?.value;
  // const pssApprovalPeriod = this.stepOneFormGroup.get('pssApprovalPeriod')?.value;

  // const ReviewPeriod = `${pssReviewNumber ?? ''} ${pssReviewPeriod ?? ''}`.trim();
  // const ApprovalPeriod = `${pssApprovalNumber ?? ''} ${pssApprovalPeriod ?? ''}`.trim();

  // console.log(ReviewPeriod);
  // console.log(ApprovalPeriod);
  // console.log(StrategyName);

  //   // 1) build your array of productJson objects
  //   const productJsonArray = this.previewData.map(entry => {
  //     const productJson: any = {
  //       language: 'en',
  //       'Product Name': entry.product,
  //       sections: [] as any[]
  //     };

  //     // — Document Control —
  //     if (entry.doc) {
  //       const docPairs = Object.entries(entry.doc).map(([k, v]) => ({
  //         Column1: k.charAt(0).toUpperCase() + k.slice(1),
  //         Column2: v
  //       }));
  //       productJson.sections.push({
  //         'Section Title': 'Document Control',
  //         'Section Type': 'key-value',
  //         DocControl: docPairs
  //       });
  //     }
  //     // — Product Overview —  ← NEW
  // if (entry.productOverview && Object.keys(entry.productOverview).length) {
  //   const overviewPairs = Object.entries(entry.productOverview).map(([k, v]) => ({
  //     Column1: k.charAt(0).toUpperCase() + k.slice(1),
  //     Column2: v
  //   }));
  //   productJson.sections.push({
  //     'Section Title': 'Product Overview',
  //     'Section Type':  'key-value',
  //     productOV:       overviewPairs
  //   });
  // }

  //       // — Activity Details —
  //     if (entry.activityDetails) {
  //       productJson.sections.push({
  //         'Section Title': 'Activity Details',
  //         'Section Type': 'table',
  //         activity: entry.activityDetails.map(a => ({ ...a }))
  //       });
  //     }

  //     // -----------Sections —---------------------------------------
  //     const sectionsFA = this.stepOneFormGroup.get('sections') as FormArray;
  //     let sectionIndex = 1;
  //     sectionsFA.controls.forEach(secCtrl => {
  //       const title = secCtrl.get('title')!.value;
  //       const type  = secCtrl.get('type')!.value;
  //       const key   = `section${sectionIndex++}`;

  //       if (type === 'Text') {
  //         const lines = (secCtrl.get('description')!.value || '')
  //           .split('\n').map(l => l.trim()).filter(Boolean);
  //         productJson.sections.push({
  //           'Section Title': title,
  //           'Section Type': 'text',
  //           [key]: lines
  //         });

  //       } else if (type === 'Table') {
  //         const headers = (secCtrl.get('columns') as FormArray)
  //                           .controls.map(c => c.value);
  //         const rows = (secCtrl.get('rows') as FormArray)
  //           .controls.map(rowFA => {
  //             const cells = (rowFA as FormArray).controls.map(c => c.value);
  //             const obj: any = {};
  //             headers.forEach((h, i) => obj[h] = cells[i]);
  //             return obj;
  //           });
  //         productJson.sections.push({
  //           'Section Title': title,
  //           'Section Type': 'table',
  //           [key]: rows
  //         });
  //       }
  //     });

  //     return productJson;
  //   });

  //     // ——— CREATE: one DTO per product ———
  //     const dtos = productJsonArray.map(pj => ({
  //       productId:       pj['Product Name'],
  //       productStrategyName: `${StrategyName} - ${pj['Product Name']}`,
  //       templateId:      this.selectedTemplateId,
  //       productStrategy: [ pj ],
  //       status:          'Yes',
  //       state,
  //       dnsId:dnsName,
  //       workspaceId:workspaceId,
  //       ReviewPeriod,
  //       ApprovalPeriod

  //     }));

  //     console.log('Create payloads:', JSON.stringify(dtos, null, 2));
  //     this.jsignalsService
  //       .createProductStrategies(dtos)
  //       .subscribe({
  //         next: (res:any) => {
  //           this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
  //           this.resetFormState();
  //           this.loadGridData();
  //           this.spinner.stop()
  //         },
  //         error: err => {
  //           console.error('Create error:', err);
  //          this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
  //           this.resetFormState();
  //           this.loadGridData();
  //           this.spinner.stop()

  //         }
  //       });

  // }

  SubmitStrategy(state: string) {
    this.spinner.start();
    const dnsName = this.localStorage.getSettings("dnsName");
    const workspaceId = this.localStorage.getSettings("WorkspaceId");
    const StrategyName = this.stepOneFormGroup.get("templateName")?.value ?? "";

    const pssReviewNumber = this.stepOneFormGroup.get("pssReviewNumber")?.value;
    const pssReviewPeriod = this.stepOneFormGroup.get("pssReviewPeriod")?.value;

    const pssApprovalNumber =
      this.stepOneFormGroup.get("pssApprovalNumber")?.value;
    const pssApprovalPeriod =
      this.stepOneFormGroup.get("pssApprovalPeriod")?.value;

    const ReviewPeriod = `${pssReviewNumber ?? ""} ${
      pssReviewPeriod ?? ""
    }`.trim();
    const ApprovalPeriod = `${pssApprovalNumber ?? ""} ${
      pssApprovalPeriod ?? ""
    }`.trim();

    // Strategy Renew Period 
     const { number: numValue, period, startDate } = this.stepOneFormGroup.value;
    const formattedDate = startDate
      ? new Date(startDate).toLocaleDateString("en-GB")
      : "";
    // const combinedStrategyReviewPeriod =
    //   numValue && period
    //     ? `Once In Every ${numValue} ${period.charAt(0).toUpperCase() + period.slice(1)}${
    //         formattedDate ? " Starting From " + formattedDate : ""
    //       }`
    //     : "";
    

    // One JSON per product
    const productJsonArray = this.previewData.map((entry) => {
      // deep clone template JSON
      const baseTemplate = JSON.parse(
        JSON.stringify(this.selectedTemplateJson)
      );

      // Add product name
      baseTemplate["Product Name"] = entry.product;

      // ---- Add Document Control ----
      if (entry.doc) {
        const docPairs = Object.entries(entry.doc).map(([k, v]) => ({
          Column1: k.charAt(0).toUpperCase() + k.slice(1),
          Column2: v,
        }));
        const docSection = baseTemplate.sections.find((s) => "DocControl" in s);
        if (docSection) {
          docSection.DocControl = docPairs;
        }
      }

      // ---- Add Product Overview ----
      if (entry.productOverview && Object.keys(entry.productOverview).length) {
        const overviewPairs = Object.entries(entry.productOverview).map(
          ([k, v]) => ({
            Column1: k.charAt(0).toUpperCase() + k.slice(1),
            Column2: v,
          })
        );
        const poSection = baseTemplate.sections.find((s) => "productOV" in s);
        if (poSection) {
          poSection.productOV = overviewPairs;
        }
      }

      // ---- Add Activity Details ----
      if (entry.activityDetails && entry.activityDetails.length) {
        const actSection = baseTemplate.sections.find((s) => "activity" in s);
        if (actSection) {
          actSection.activity = entry.activityDetails.map((a) => ({ 
            ...a,
        //     rolesAllowed: Array.isArray(a.rolesAllowed)
        // ? a.rolesAllowed.join(",")  // <-- convert array to CSV rolesAllowed 
        // : a.rolesAllowed,
        startDate: this.jsignalsService.toYYYYMMDD(a.startDate),})); //convert startDate to YYYY/MM/DD
        }
      }

      return baseTemplate;
    });

    // DTO build
     /**
   * @Modified Rahul Vk
   * @Date 14-11-2025
   * @Desc Storing the productId of each selected product from productIdMap if not id send the null--> Fallback
   */   
    const dtos = productJsonArray.map((pj) => {
  const prodName = pj["Product Name"];
  const prodId = this.productIdMap.get(prodName) ?? null; // fallback if missing

  return {
    productId: prodId,
    productStrategyName: `${StrategyName} - ${prodName}`,
    templateId: this.selectedTemplateId,
    productStrategy: [pj],
    status: "Yes",
    state,
    dnsId: dnsName,
    workspaceId,
    ReviewPeriod,
    ApprovalPeriod,
    renewalPeriodSchedulerId: this.scheduleid,
  };
});


    console.log("Create payloads:", JSON.stringify(dtos, null, 2));

    this.jsignalsService.createProductStrategies(dtos).subscribe({
      next: (res: any) => {
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        this.resetFormState();
        this.loadGridData();
        this.spinner.stop();
      },
      error: (err) => {
        console.error("Create error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        this.resetFormState();
        this.loadGridData();
        this.spinner.stop();
      },
    });
  }

  filterProducts() {
    const search = this.productSearchText.toLowerCase();
    this.filteredProducts = this.productOptions.filter((p) =>
      p.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterActivities() {
    const search = this.activitySearchText?.toLowerCase() || "";
    this.filteredActivities = this.activityOptions.filter((a) =>
      a.lookupvalue?.toLowerCase().includes(search)
    );
  }

  clearProductSearch() {
    this.productSearchText = "";
    this.filteredProducts = [...this.productOptions];
  }
  clearActivitySearch() {
    this.activitySearchText = "";
    this.filteredActivities = [...this.activityOptions];
  }

  onPaginationChanged() {
    if (this.gridmgrnAPI && !this.gridmgrnAPI.destroyed) {
      this.RunlastPage = this.gridmgrnAPI.paginationIsLastPageFound();
      this.RuncurrentPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1;
      this.RunnextPage = this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1;
      this.RunnextPagePlusOne =
        this.gridmgrnAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.RuntotalPages = this.gridmgrnAPI.paginationGetTotalPages();
    }
  }

  onGridReady(params: any) {
    debugger;
    this.gridAPI = params.api;
    this.gridmgrnAPI = params.api;
    this.gridColumnAPI = params.api;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(this.RunpageSize));

    // Build the list shown in the dropdown: only columns that have a field and are not pinned left
    this.toggleableCols = this.columnDefs
      .filter((c) => !!c.field && !c.pinned) // keep "Action" out of the picker
      .map((c) => ({ headerName: c.headerName, field: c.field }));

    // Selected = all non-hidden fields by default
    this.selectedFields = this.columnDefs
      .filter((c) => !!c.field && !c.hide)
      .map((c) => c.field);

    // Apply the "Latest Only" filter if default is true
    if (this.showLatestOnly) {
      this.onToggleLatestOnly(true);
    }
  }

  onDownloadhistory() {
    if (this.isDownloading) return;

    this.isDownloading = true;
    this.spinner.start();

    setTimeout(() => {
      this.gridmgrnAPI.exportDataAsCsv({
        fileName: "SafetyStrategy.csv",
      });

      this.spinner.stop();
      this.isDownloading = false;
    }, 500);
  }

  onRunSearchChange(searchValue: number) {
    this.gridmgrnAPI.paginationGoToPage(searchValue - 1);
  }
  onRunPageSizeChanged(newPageSize) {
    console.log(this.RunpageSize);
    var value = this.RunpageSize;
    this.gridmgrnAPI.setGridOption('paginationPageSize', Number(value));
  }
  onRunBtFirst() {
    this.gridmgrnAPI.paginationGoToFirstPage();
  }
  onRunBtPrevious() {
    console.log("previous");
    this.gridmgrnAPI.paginationGoToPreviousPage();
  }
  onRunBtNext() {
    console.log("next");
    this.gridmgrnAPI.paginationGoToNextPage();
  }
  onRunBtLast() {
    this.gridmgrnAPI.paginationGoToLastPage();
  }

  onAdd() {
    this.isEditMode = false;
    this.editJson = null;
    this.templateForm.reset(); // Reset before opening

    const dialogRef = this.dialog.open(this.templateDialog, {
      width: "800px",
      height: "500px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.templateId = this.templateForm.value.templateId;
        this.selectedProducts = this.templateForm.value.products;
        console.log(this.templateId);
        console.log(this.selectedProducts);
      }
    });
  }

  onTemplateDialogNext(): void {

  if (this.templateForm.invalid) {
    this.templateForm.markAllAsTouched();
    return;
    }

    const mode = this.templateForm.value.selectionType;
    const selectedProducts = this.templateForm.get("products")?.value; // array
    const selectedTemplate = this.templateForm.get("templateId")?.value; // string
    this.showDocumentSections = false;

    this.selectedProductsFromDialog = selectedProducts;
    console.log("Products Selected",this.selectedProductsFromDialog);
    const pendingTemplateId = selectedTemplate;

    // 1) close the dialog
    this.dialog.closeAll();
    setTimeout(() => {
      // 2) immediately show & initialize
      this.showWorkflow = true;
      this.initializeFormGroups();
      if (this.isEditMode && this.editJson) {
        this.loadFromProductJson(this.editJson);
      } else {
        this.onTemplateSelected(pendingTemplateId);
        console.log("Loading template:", pendingTemplateId);
      }
      this.templateId = pendingTemplateId;
      this.cdr.detectChanges();
    }, 0);
  }

  EditIcon({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    if (rowData.is_Latest == false) {
      this.snackBar.open("Older Version Not Allowed To Edit ", "OK", {
        duration: 5000,
      });
      return;
    }

    if (rowData.state === "Approved") {
      this.snackBar.open("Approved Document Not Allowed To Edit", "OK", {
        duration: 5000,
      });
      return;
    }

    if (rowData.state === "In Approval") {
      this.snackBar.open(
        "Document is  In Approval Not  Allowed To Edit",
        "OK",
        { duration: 5000 }
      );
      return;
    }

    //after creating user group attach userrrole from that table
    this.userRole = "author";
    this.isPreview = false;
    this.ProductID = rowData.productId;
    console.log(this.ProductID);
    // Parse JSON safely
    let parsed: any;
    this.isEditMode = true;
    // this productstrategyid common id
    this.productStrategyIdToEdit = rowData.productStrategyId;
    console.log(this.productStrategyIdToEdit);

    const pendingTemplateId = rowData.templateName;
    this.docVersion = rowData.version;

    //state variable used to store the PSS State from the Grid And Pass to Stepper Form Component as Input
    this.state = rowData.state;
    console.log(this.state);

    this.pssId = rowData.id;
    console.log(this.pssId);

    // Clear any existing interval before starting a new one
    if (this.reviewRefreshInterval) {
      clearInterval(this.reviewRefreshInterval);
    }

    console.log("StrategyID", this.productStrategyIdToEdit);

    //Intially load Comments
    this.fetchLatestComments();

    // Only start Refresh if we actually have a valid ID
    if (this.productStrategyIdToEdit) {
      this.fetchLatestComments();
      // Refresh Json Every 30 Sec
      this.reviewRefreshInterval = setInterval(() => {
        this.fetchLatestComments();
      }, 10000);
    }

    this.fetchLatestJson();
    this.rowDataForEdit = rowData;

    console.log(this.rowDataForEdit);

    this.templateForm.patchValue({
      templateId: pendingTemplateId,
      products: [this.productName],
    });
    this.templateId = pendingTemplateId;
  }

  fetchLatestComments() {
    console.log("StrategyID", this.productStrategyIdToEdit);
    //The below condition prevents api call for the selected strategy id after cancel
    if (this.productStrategyIdToEdit == null) {
      return;
    }
    //Below Method Used To Load the Initial Comment For the Selected Strategy
    this.loadCommentsForStrategy(this.productStrategyIdToEdit);
  }

  async onJsonUpdated(updatedJson: any) {
    
    const newHash = await this.jsignalsService.getJsonHash(updatedJson);
    console.log("New hash:", newHash);
    console.log("Original hash:", this.originalHash);
    console.log("Is Json Changed =",this.originalHash && newHash === this.originalHash);

    if (this.originalHash && newHash === this.originalHash) {
    this.snackBar.open("No changes detected. Update has been cancelled.", "OK", { duration: 4000 });
    return;
    }
    // Only proceed if actual changes are found
    this.sendUpdate(updatedJson, "RESUBMIT");

    // this.autoSave(updatedJson, 'IN_REVIEW');
  }

  onEditCancel(resetFlag?: boolean) {
    this.productMeta=null
    if (resetFlag) {
      this.isFirstLoad = true; //  reset on cancel
    }
    this.productStrategyIdToEdit = null;
    console.log("StrategyID", this.productStrategyIdToEdit);
    // this.templateId = null;
    // this.isEditMode = false;
    this.resetFormState();
    localStorage.removeItem("allCommentsJson");
    this.loadGridData();
  }

  handleReviewerAction(event: { id: number; action: string; comment: string }) {
    //   console.log(event);
    //   const commentby = this.localStorage.getSettings('AuthUsername');
    // this.jsignalsService.reviewerAction(event.id, event.action, event.comment,this.docVersion,commentby).subscribe({
    //   next: (res:any) => {
    //      this.snackBar.open(res.statusMessage, 'Ok', { duration: 3000 });
    //       this.loadGridData();
    //   },
    //   error: (err) => {
    //     this.snackBar.open(err.error.statusMessage, 'Ok', { duration: 3000 });
    //      this.loadGridData();
    //     console.error(err);
    //   }
    // });
  }

  onSaveJson(updatedJson: any) {
    this.sendUpdate(updatedJson, "DRAFT");
    this.resetFormState();
  }

  onDraftSubmit(updatedJson: any) {
    this.sendUpdate(updatedJson, "SUBMIT");
    this.resetFormState();
  }

  deleteIcon({ event, rowData }: any): void {
    if (rowData.is_Latest == false) {
      this.snackBar.open("Older Version Not Allowed To Delete ", "OK", {
        duration: 5000,
      });
      return;
    }
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    if (rowData.state === "Approved") {
      this.snackBar.open("Approved Document Not Allowed To Delete ", "OK", {
        duration: 5000,
      });
      return;
    }
    if (rowData.state === "In Review") {
      this.snackBar.open(" Document In Review Not Allowed To Delete", "OK", {
        duration: 5000,
      });
      return;
    }
    if (rowData.state === "In Approval") {
      this.snackBar.open(
        "Document is  In Approval Not  Allowed To Delete",
        "OK",
        { duration: 5000 }
      );
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete the selected record ?"
    );
    if (!confirmed) {
      return;
    }

    this.spinner.start();
    this.pssId = rowData.id;
    console.log(this.pssId);

    this.jsignalsService.deleteProductStrategy(this.pssId).subscribe({
      next: (res: any) => {
        console.log(res);
        console.log("statusMessage:", res.statusMessage);
        this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
        this.spinner.stop();
        this.loadGridData();
      },
      error: (err) => {
        console.error(" Delete error:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
        this.spinner.stop();
        this.loadGridData();
      },
    });
  }

 cancelWorkflow(): void {
 
  // Confirm only if schedule exists
  if (this.scheduleid) {
    const confirmed = window.confirm(
      "If you go back now, the schedule you created will be permanently deleted. Do you want to continue?"
    );
    if (!confirmed) {
      return; // stop the function
    }
  }

  // Now safe to proceed
  (document.activeElement as HTMLElement | null)?.blur();
  this.showWorkflow = false;
  this.templateId = null;
  this.isEditMode = false;

  this.deleteSchedule();
  localStorage.removeItem('uniquenumberForPssScheduler');
  this.scheduleid = null;
  this.selectSchedule = null;
}


  addStepOneSection() {
    this.stepOneSections.push(
      this.fb.group({
        type: ["Text"],
        title: ["", Validators.required],
        description: [""],
      })
    );
  }

  // Called by each remove‑icon button
  removeStepOneSection(index: number) {
    this.stepOneSections.removeAt(index);
  }
  onPageChangeEvent(event) {
    const newPage = event;
    this.flipState = newPage > this.currentProductPage ? "next" : "prev";

    // give the animation time to run before resetting
    setTimeout(() => (this.flipState = "none"), 600);

    this.currentProductPage = newPage;
  }

  onPageChange(event: PageEvent) {
    const newPage = event.pageIndex;
    this.flipState = newPage > this.currentProductPage ? "next" : "prev";

    // give the animation time to run before resetting
    setTimeout(() => (this.flipState = "none"), 600);

    this.currentProductPage = newPage;
  }

  downloadWord({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    if(rowData.wordDocGenerationStatus == null){
      this.snackBar.open("Word document not generated for this PSS", "OK", { duration: 3000 });
      return;
    }
    if(rowData.wordDocGenerationStatus ===  "In Progress"){
      this.snackBar.open("Word Generation is in Progress. Please try again Later", "OK", { duration: 3000 });
      return;
    }
    if (rowData.wordDocGenerationStatus ===  "Failed") {
      this.snackBar.open("Word Generation Failed", "OK", { duration: 3000 });
      return;
    }
    if (rowData.state !==  "Approved") {
      this.snackBar.open("Only approved documents can be downloaded.", "OK", { duration: 3000 });
      return;
    }
    this.spinner.start();
    this.snackBar.open(
      "Download is underway. Please do not click again the download until it completes the download.",
      "OK",
      { duration: 10000 }
    );
    this.spinner.stop();
    this.jsignalsService.getApprovedLatestPssDocument(rowData.productStrategyId,"WORD")
  .subscribe({
    next: (response: any) => {
      const fileBlob = new Blob([response.body], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });
      console.log(response.body);

      console.log(response.headers);
      const contentDisposition = response.headers.get('content-disposition');
      let fileName = `${rowData.productStrategyName}.docx`;

      if (contentDisposition) {
        const matches = /filename="([^"]+)"/.exec(contentDisposition);
        if (matches && matches[1]) {
          fileName = matches[1];
        }
      }

      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.remove();
      }, 200);

      this.snackBar.open("Download completed", "OK", { duration: 3000 });
    },
    error: () => {
      this.snackBar.open("File Not Found", "OK", { duration: 3000 });
    }
  }).add(() => this.spinner.stop());
  }

  downloadPdf({ event, rowData }: any): void {
    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
     if(rowData.wordDocGenerationStatus == null){
      this.snackBar.open("Pdf document not generated for this PSS", "OK", { duration: 3000 });
      return;
    }
    if(rowData.wordDocGenerationStatus ===  "In Progress"){
      this.snackBar.open("Pdf Generation is in Progress. Please try again Later", "OK", { duration: 3000 });
      return;
    }
    if (rowData.wordDocGenerationStatus ===  "Failed") {
      this.snackBar.open("Pdf Generation Failed", "OK", { duration: 3000 });
      return;
    }
    if (rowData.state !==  "Approved") {
      this.snackBar.open("Only approved documents can be downloaded.", "OK", { duration: 3000 });
      return;
    }
    
     this.spinner.start();
      this.snackBar.open(
      "Download is underway. Please do not click again the download until it completes the download.",
      "OK",
      { duration: 10000 }
    );
    // this.spinner.stop();

  this.jsignalsService
    .getApprovedLatestPssDocument(rowData.productStrategyId,"PDF")
    .subscribe({
      next: (response: any) => {

        const fileName = `${rowData.productStrategyName}.pdf`;

        const blob = new Blob([response.body], {
          type: 'application/pdf' // FORCE PDF
        });

        this.forceDownload(blob, fileName);
      },
      error: () => {
        this.snackBar.open("File Not Found", "OK", { duration: 3000 });
      }
    })
    .add(() => this.spinner.stop());
  }

    private forceDownload(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      link.remove();
    }, 200);
    this.loadGridData();
    this.snackBar.open("Download completed", "OK", { duration: 3000 });
  }


  getProductMeta(productName: string) {
    return this.productDocumentControls[productName];
  }

  // // 2) When user moves over the grid, update selection
  onGridHover(rows: number, cols: number) {
    this.tableRows = rows;
    this.tableCols = cols;
  }

  // // 3) Push an “empty” table section into your FormArray
  addTableSection(rows: number, cols: number) {
    // build a FormArray of `cols` empty header controls:
    const colArray = this.fb.array(
      Array(cols)
        .fill(0)
        .map(() => this.fb.control(""))
    );
    // build a FormArray of `rows` FormArrays, each with `cols` empty cells:
    const rowArray = this.fb.array(
      Array(rows)
        .fill(0)
        .map(() =>
          this.fb.array(
            Array(cols)
              .fill(0)
              .map(() => this.fb.control(""))
          )
        )
    );

    this.stepOneSections.push(
      this.fb.group({
        type: ["Table"],
        title: ["", Validators.required],
        // keep the same JSON shape you had before:
        columns: colArray,
        rows: rowArray,
      })
    );

    // reset hover so it doesn’t show stale numbers if reopened:
    this.tableRows = this.tableCols = 0;
  }

  loadFromDefault(json: any) {
    const sectionsFA = this.stepOneFormGroup.get("sections") as FormArray;
    sectionsFA.clear();

    // Helper to get the main payload of a section
    function getEachSectionKey(section: any): any {
      if (!section || typeof section !== "object") return null;
      const key = Object.keys(section).find(
        (k) => k !== "Section Title" && k !== "Section Type"
      );
      return key ? section[key] : null;
    }

    // STEP 1: Patch template name (from doc section if present)
    const docSection = json.sections.find((s: any) => "DocControl" in s);
    if (docSection) {
      const docData =
        (getEachSectionKey(docSection) as Array<{
          Column1: string;
          Column2: any;
        }>) || [];
      const titleFromDoc = docData.find(
        (d) => d.Column1 === "Document Title"
      )?.Column2;
      this.stepOneFormGroup.patchValue({
        templateName: titleFromDoc || "",
      });
    }

    // STEP 2: Extract and patch activities (if present)
    const activitySection = json.sections.find((s: any) =>
      Array.isArray(s.activity)
    );
    const activities = activitySection?.activity?.map((a) => a.activity) || [];
    this.stepOneFormGroup.patchValue({ activities });
    this.selectedActivities = activities;

    // STEP 3: Build sections array (skip doc + activity)
    for (const sec of json.sections) {
      if ("DocControl" in sec || "activity" in sec || "productOV" in sec)
        continue;

      const title = sec["Section Title"];
      const type = sec["Section Type"];
      const payload = getEachSectionKey(sec);

      if (type === "table" && Array.isArray(payload)) {
        const colsSet = new Set<string>();
        payload.forEach((row) =>
          Object.keys(row).forEach((k) => colsSet.add(k))
        );
        const cols = Array.from(colsSet);
        const rows = payload.map((r) =>
          this.fb.array(cols.map((c) => r[c] ?? ""))
        );
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Table",
            title,
            columns: this.fb.array(cols),
            rows: this.fb.array(rows),
          })
        );
      } else {
        const lines = Array.isArray(payload) ? payload : [];
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Text",
            title,
            description: lines.join("\n"),
          })
        );
      }
    }

    this.cdr.markForCheck();
  }

  loadFromProductJson(json: any) {
    this.spinner.start();
    const sectionsFA = this.stepOneFormGroup.get("sections") as FormArray;
    const actsFA = this.stepTwoFormGroup.get("activityConfigs") as FormArray;

    sectionsFA.clear();
    actsFA.clear();

    // ── Helper to safely extract payload from a section (e.g., DocControl, section1, etc.)
    function getEachSectionKey(section: any): any {
      if (!section || typeof section !== "object") return null;
      const key = Object.keys(section).find(
        (k) => k !== "Section Title" && k !== "Section Type"
      );
      return key ? section[key] : null;
    }

    // ── STEP 1: extract Document Control data by checking for 'DocControl' key
    const docSection = json.sections.find((s: any) => "DocControl" in s);
    const docData =
      (getEachSectionKey(docSection) as Array<{
        Column1: string;
        Column2: any;
      }>) || [];

    // Patch form header
    const docPatch: any = {};
    for (const { Column1, Column2 } of docData) {
      const key = Column1.charAt(0).toLowerCase() + Column1.slice(1);
      docPatch[key] = Column2;
    }
    // this.stepOneFormGroup.patchValue({ doc: docPatch });

    // ── STEP 2: extract activity section (detect by existence of `activity` key)
    const activitySection = json.sections.find((s: any) =>
      Array.isArray(s.activity)
    );
    const details = activitySection?.activity || [];
    const activities = details.map((a) => a.activity);

    this.stepOneFormGroup.patchValue({ activities });
    this.selectedActivities = activities;

    // ── STEP 3: dynamically rebuild every other section (skip doc + activities)
    for (const sec of json.sections) {
      if ("DocControl" in sec || "activity" in sec || "productOV" in sec)
        continue;

      const title = sec["Section Title"];
      const type = sec["Section Type"];
      const payload = getEachSectionKey(sec);

      if (type === "table" && Array.isArray(payload)) {
        const colsSet = new Set<string>();
        payload.forEach((row) => {
          Object.keys(row).forEach((k) => colsSet.add(k));
        });
        const cols = Array.from(colsSet);

        const rows = payload.map((r) =>
          this.fb.array(cols.map((c) => r[c] ?? ""))
        );

        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Table",
            title,
            columns: this.fb.array(cols),
            rows: this.fb.array(rows),
          })
        );
      } else if (type === "key-value" && Array.isArray(payload)) {
        const desc = payload
          .map((d: any) => `${d.Column1}: ${JSON.stringify(d.Column2)}`)
          .join("\n");
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Text",
            title,
            description: desc,
          })
        );
      } else {
        const lines = Array.isArray(payload) ? payload : [];
        sectionsFA.push(
          this.fb.group({
            key: title,
            type: "Text",
            title,
            description: lines.join("\n"),
          })
        );
      }
    }

    // ── STEP 4: rebuild activityConfigs
    for (const det of details) {
      actsFA.push(
        this.fb.group({
          activity: [det.activity || ""],
          reviewPeriod: [det.reviewPeriod || ""],
          dueDays: [det.dueDays ?? null],
          originalReviewPeriod: [det.originalReviewPeriod || ""],
          originalDueDays: [det.originalDueDays ?? null],
          evidenceRequired: [det.evidenceRequired || "No"],
          uploadInstructions: [det.uploadInstructions || ""],
          // rolesAllowed: [
          //   Array.isArray(det.rolesAllowed) ? det.rolesAllowed : [],
          // ],
          startDate: [det.startDate ? new Date(det.startDate) : null],
        })
      );
    }

    this.cdr.markForCheck();
    this.spinner.stop();
  }

  getProductJsonByProductName(name: string): any {
    return this.productJsonMap[name] || null;
  }

  initializeFormGroups(): void {
    this.stepOneFormGroup = this.fb.group({
      templateName: ["", Validators.required],
      description: [""],
      activities: [[]],
      reviewPeriod: [""],
      dueDays: [""],
      strategyReviewPeriod: [""],
      // number: [1, [Validators.min(0)]],
      // period: ["months"],
      // startDate: [null],
      sections: this.fb.array([]), // 👈 must exist
      // NEW: PSS review & approval fields (defaults to 7 Days as you showed)
      pssReviewNumber: [7, [Validators.min(0)]],
      pssReviewPeriod: ["Days"],
      pssApprovalNumber: [7, [Validators.min(0)]],
      pssApprovalPeriod: ["Days"],
      selectschedule:["",Validators.required],
      level: ["", Validators.required],
    });

    this.stepTwoFormGroup = this.fb.group({
      activityConfigs: this.fb.array([]),
    });
  }

  getOverviewOfEachSelectedProduct(key: string): string {
    return (
      key
        // insert space before any capital letter
        .replace(/([A-Z])/g, " $1")
        // underscores → spaces
        .replace(/_/g, " ")
        // uppercase first character
        .replace(/^./, (str) => str.toUpperCase())
        .trim()
    );
  }

  /** Called when the user drags a document‑section card into a new position */
  onSectionReorder(e: CdkDragDrop<FormGroup[]>) {
    // re‐order the FormArray itself:
    const fa = this.stepOneSections;
    moveItemInArray(fa.controls, e.previousIndex, e.currentIndex);
    fa.updateValueAndValidity();
  }

  /** Called when the user drags an activity into a new position */
  onActivityReorder(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;

    const fa = this.stepTwoFormArray;
    const moved = fa.at(event.previousIndex);
    fa.removeAt(event.previousIndex);
    fa.insert(event.currentIndex, moved);

    // Rearrange selectedActivities array if you're using that for labels
    const act = this.selectedActivities.splice(event.previousIndex, 1)[0];
    this.selectedActivities.splice(event.currentIndex, 0, act);
  }

  OnSave() {
    this.SubmitStrategy("DRAFT");
  }

  onTemplateSelected(templateName: string) {
    console.log("Template selected:", templateName);

    this.jsignalsService.getTemplateByName(templateName).subscribe({
      next: (res) => {
        try {
          // Parse the JSON string if needed
          const parsedJson =
            typeof res.templateContent === "string"
              ? JSON.parse(res.templateContent)
              : res.templateContent;

          // Pass parsed JSON directly
          console.log(JSON.stringify(parsedJson, null, 2));
          this.selectedTemplateJson = parsedJson;
          this.loadFromDefault(parsedJson);

          // Store template id for later use
          this.selectedTemplateId = res.templateId;
          console.log(this.selectedTemplateId);
        } catch (err) {
          console.error("Error parsing templateContent:", err);
        }
      },
      error: (err) => {
        console.error("Error loading template JSON:", err);
      },
    });
  }

  //new
  loadGridData() {
    this.spinner.start();
    this.gridRowData = [];

    this.jsignalsService.getAllProductStrategies().subscribe({
      next: (res: any[]) => {
        console.log("API returned:", res);
 
       this.gridRowData = this.processResponseData(res);

      console.log("Processed grid data:", this.gridRowData);
      
      this.productStrategyData = this.gridRowData; // keep original for filtering

      if(this.productMeta) {
        let getProductData = this.productStrategyData.filter(item => item.productName == this.productMeta.productName)  
        console.log(getProductData);
        const params = {
          event: null,
          rowData: getProductData[0],
        };
        this.previewFile(params)
      }
        
      },
      error: (err) => {
        console.error("❌ Error loading product strategies:", err);
        this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
      },
      complete: () => {
        this.spinner.stop();
      },
    });
  }
removeFilterShowAllRows(){
   this.gridRowData=this.productStrategyData;
   this.productMeta=null
}
  onrefresh() {
    this.loadGridData();
  }
  ngOnDestroy(): void {
    this.gridmgrnAPI = null;
    if (this.autoSaveTimer) {
      clearTimeout(this.autoSaveTimer);
    }
    if (this.reviewRefreshInterval) {
      clearInterval(this.reviewRefreshInterval);
    }
    localStorage.removeItem("allCommentsJson");
  }
  resetFormState(): void {
    this.productStrategyIdToEdit = null;
    this.pssId = null;
    this.isEditMode = false;
    this.templateForm.reset();
    this.stepOneFormGroup.reset();
    this.stepTwoFormGroup.reset();
    this.showWorkflow = false;
    this.templateId = null;
    this.selectedTemplateJson = null;
    this.allComments = [];
    this.uniquenumber = null;
    this.scheduleid = null;
    this.selectSchedule = null;
    localStorage.removeItem('uniquenumberForPssScheduler');
  }

  // format date as "DD-MMM-YYYY HH:MM:SS GMT"
  private formatCreatedDateUTC(date: Date): string {
    const pad = (n: number) => (n < 10 ? "0" + n : n);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = date.getUTCDate();
    const m = months[date.getUTCMonth()];
    const y = date.getUTCFullYear();
    const hh = pad(date.getUTCHours());
    const mm = pad(date.getUTCMinutes());
    const ss = pad(date.getUTCSeconds());
    return `${d}-${m}-${y} ${hh}:${mm}:${ss} GMT`;
  }

  // skeleton for create-mode: defaults version -> '0.1' and CreatedDate -> now (UTC)
  private buildDocControlSkeleton(name: string): DocumentControl {
    const { number: numValue, period, startDate } = this.stepOneFormGroup.value;
    const selectedLevel = this.stepOneFormGroup.get("level")?.value;
    const formattedDate = startDate
      ? new Date(startDate).toLocaleDateString("en-GB")
      : "";
    // const combinedStrategyReviewPeriod =
    //   numValue && period
    //     ? `Once In Every ${numValue} ${period.charAt(0).toUpperCase() + period.slice(1)}${
    //         formattedDate ? " Starting From " + formattedDate : ""
    //       }`
    //     : "";
    return {
      name,
      version: "0.1", // default for new strategies
      CreatedDate: this.formatCreatedDateUTC(new Date()), // now in UTC formatted string
      author: this.localStorage.getSettings?.("AuthUser") || null,
      reviewers: "",
      approver: "",
      approvedDate: "",
      status: "",
      renewalPeriodSchedulerId: this.selectSchedule,
      level:selectedLevel,
    };
  }

  // --- helper: extract DocumentControl map from stored rowData (edit mode) ---
  // returns map keyed by product name: { "METACIN": DocumentControl, ... }
  private extractDocControlsFromRowData(
    rowData: any
  ): Record<string, DocumentControl> {
    const map: Record<string, DocumentControl> = {};
    if (!rowData) return map;

    try {
      const raw = rowData.productStrategyJson;
      const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      const data = Array.isArray(parsed) ? parsed[0] : parsed;

      const sections = data?.sections || [];
      const docSection = sections.find(
        (s: any) => s["Section Title"] === "Document Control"
      );

      if (docSection?.DocControl && Array.isArray(docSection.DocControl)) {
        // DocControl is array of { Column1, Column2 } pairs
        const obj: any = {};
        docSection.DocControl.forEach((r: any) => {
          obj[r.Column1] = r.Column2;
        });

        // product name fallback: obj.Name or top-level Product Name
        const productName =
          (obj.Name && String(obj.Name).trim()) ||
          data["Product Name"] ||
          rowData.productid ||
          "";
        if (productName) {
          map[productName] = {
            name: productName,
            version: obj.Version ?? rowData.version ?? null,
            CreatedDate: obj.CreatedDate ?? rowData.CreatedDate ?? null,
            author: obj.Author ?? rowData.Author ?? null,
            // Always make reviewers an array
            reviewers: (() => {
              if (Array.isArray(obj.Reviewers)) {
                return obj.Reviewers;
              } else if (obj.Reviewers) {
                return [obj.Reviewers]; // wrap single into array
              } else if (rowData.reviewerName) {
                return [rowData.reviewerName]; // fallback
              }
              return [];
            })(),

            // Always make approver an array
            approver: (() => {
              if (Array.isArray(obj.Approver)) {
                return obj.Approver;
              } else if (obj.Approver) {
                return [obj.Approver];
              } else if (rowData.approverName) {
                return [rowData.approverName];
              }
              return [];
            })(),
            approvedDate: obj.approvedDate ?? rowData.approvedDate ?? "",
            status: obj.state ?? rowData.state ?? "",
            renewalPeriodSchedulerId:obj.renewalPeriodSchedulerId ?? rowData.renewalPeriodSchedulerId ?? "",
            level:obj.level ?? rowData.level ?? ""
          };
        }
      }

      // also try to catch doc control values saved directly on rowData (fallback)
      if (!Object.keys(map).length && rowData.productid) {
        map[rowData.productid] = {
          name: rowData.Name,
          version: rowData.Version ?? null,
          CreatedDate: rowData.CreatedDate ?? null,
          author: rowData.Author ?? null,
          reviewers: rowData.Reviewers
            ? Array.isArray(rowData.reviewer)
              ? rowData.reviewer
              : [rowData.reviewer]
            : [],
          approver: rowData.Approver ?? "",
          approvedDate: rowData.approvedDate ?? "",
          status: rowData.state ?? "",
          renewalPeriodSchedulerId: rowData.renewalPeriodSchedulerId ?? "",
          level:rowData.level ?? ""
        };
      }
    } catch (e) {
      // parse error - return empty map; create-mode will handle skeletons
      console.warn("extractDocControlsFromRowData parse error", e);
    }

    return map;
  }

onHeaderCheckboxChange(checked: boolean) {
  const updatedRows: any[] = [];
  const isFilterActive = this.gridAPI.isAnyFilterPresent();

  const processNode = (node: any) => {
    const row = node.data;
    const isDeleted = row?.status === "No";

    if (!isDeleted) {
      row.isSelected = checked;

      if (checked) {
        updatedRows.push(row);
      }
    } else {
      row.isSelected = false; //  Always force unselected for deleted rows
    }
  };

  if (checked) {
    if (isFilterActive) {
      this.gridAPI.forEachNodeAfterFilter(processNode);
    } else {
      this.gridAPI.forEachNode(processNode);
    }
  } else {
    this.gridAPI.forEachNode((node) => (node.data.isSelected = false));
  }

  this.selectedRows = updatedRows;

  //Refresh the Action column
  this.gridAPI.refreshCells({
    force: true,
  });

  console.log("Selected rows after header click:", this.selectedRows);
}

  checkboxIcon(event: any) {
    const row = event?.rowData;
    // if (!row) return; // Defensive: exit if no row data

    if (event.checked) {
      // Add row if not already present
      const exists = this.selectedRows.find((r) => r.id === row.id);
      if (!exists) {
        this.selectedRows.push(row);
      }
    } else {
      // Remove row on uncheck
      this.selectedRows = this.selectedRows.filter((r) => r.id !== row.id);
    }

    // Force change detection by creating a new array reference
    this.selectedRows = [...this.selectedRows];

    console.log("Updated selected rows:", this.selectedRows);
  }

  toggleColumn(field: string, visible: boolean) {
    if (this.gridAPI) {
      this.gridColumnAPI?.setColumnVisible(field, visible);
    }
  }
  // --- when user changes selection in the dropdown ---
  onColumnSelectionChange(evt: any) {
    this.selectedFields = evt.value as string[];
    this.applySelectionToGrid();
  }

  // --- helpers ---
  applySelectionToGrid() {
    if (!this.gridColumnAPI) return;

    const selected = new Set(this.selectedFields);

    // toggle only toggleable columns; leave pinned “Action” alone
    for (const c of this.toggleableCols) {
      this.gridColumnAPI.setColumnsVisible([c.field], selected.has(c.field));
    }
  }

  selectAll() {
    this.selectedFields = this.toggleableCols.map((c) => c.field);
    this.applySelectionToGrid();
  }

  clearAll() {
    this.selectedFields = [];
    this.applySelectionToGrid();
  }

  openColumnsDialog() {
    const dialogRef = this.dialog.open(ColumnsDialogComponent, {
      maxWidth: "100vw",
      height: "55%",
      width: "45%",
      data: {
        toggleableCols: this.toggleableCols,
        selectedFields: this.selectedFields,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: string[] | undefined) => {
      if (result) {
        this.selectedFields = result;
        this.applySelectionToGrid(); // update AG Grid
      }
    });
  }

  onToggleLatestOnly(checked: boolean) {
    if (!this.gridAPI) return;

    if (checked) {
      this.gridAPI.setFilterModel({
        is_Latest: {
          type: "equals",
          filter: true,
        },
      });
    } else {
      // clear filters
      this.gridAPI.setFilterModel(null);
    }

    this.gridAPI.onFilterChanged();
  }

  private sendUpdate(updatedJson: any, state: string) {
    this.spinner.start();
    this.ModifiedJSonInEdit = updatedJson;

    const dnsName = this.localStorage.getSettings("dnsName");
    const workspaceId = this.localStorage.getSettings("WorkspaceId");
    // ID is Unique id for each Pss
    const ID = this.rowDataForEdit.id;
    console.log(ID);

    // productStrategyId is Common id For Each Pss With Different Version
    const productStrategyId = this.rowDataForEdit.productStrategyId;
    console.log(productStrategyId);

    const dto = {
      productId: this.rowDataForEdit.productId,
      templateId: this.selectedTemplateId,
      productStrategyName: this.rowDataForEdit.productStrategyName,
      productStrategy: [this.ModifiedJSonInEdit],
      status: "Yes",
      state: state, // dynamic state
      dnsId: dnsName,
      workspaceId: workspaceId,
    };

    this.jsignalsService
      .updateProductStrategy(productStrategyId, dto)
      .subscribe({
        next: (res: any) => {
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          console.log("Sending update DTO with state =", state, dto);
          // this.resetFormState();
          // this loading of grid data is required when PSS is in Draft--> Submit
          this.loadGridData();
          this.fetchLatestJson();
          this.spinner.stop();
        },
        error: (err) => {
          console.error("Update error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.resetFormState();
          this.loadGridData();
          this.spinner.stop();
        },
      });
  }

  onSectionChange(sectionId: string) {
    this.currentSectionId = sectionId; // pass to comments component
    console.log(sectionId);
  }
  cancelcommnents(resetFlag?: boolean) {
    if (resetFlag) {
      this.isFirstLoad = true; //  reset on cancel
    }
    this.productStrategyIdToEdit = null;
    localStorage.removeItem("allCommentsJson");
    this.resetFormState();
    this.loadGridData();
  }

  previewFile({ event, rowData }: any): void {
    console.log("888888888888888888888888888888888888888888");
    console.log(rowData);
    
    
    //In Preview It is Read only [reviewer role is read only ]
    this.userRole = "reviewer";
    this.isPreview = true;

    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    // Parse JSON safely
    let parsed: any;
    this.isEditMode = true;
    this.productStrategyIdToEdit = rowData.productStrategyId;
    const pendingTemplateId = rowData.templateName;
    this.docVersion = rowData.version;

    try {
      const raw = rowData.productStrategyJson;
      parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
      if (Array.isArray(parsed)) parsed = parsed[0];
    } catch (e) {
      console.error("could not parse productStrategyJson:", e);
      this.snackBar.open(`Invalid Json - ${e}`, "Ok", {
              duration: 4000,
            });
            // Cancel preview If Any Error Occured 
            this.onEditCancel();
      return;
    }

    this.ProductStrategyJson = parsed;
    this.rowDataForEdit = rowData;

    console.log(this.rowDataForEdit);

    this.templateForm.patchValue({
      templateId: pendingTemplateId,
      products: [this.productName],
    });
    this.templateId = pendingTemplateId;
  }

  onCommentCountsUpdated(counts: { [sectionId: string]: number }) {
    this.commentCountMap = counts;
    console.log(this.commentCountMap);
  }

  // below code is used send live document update to db

  // autoSave(updatedJson: any, state: string) {
  //   // clear any existing debounce
  //   this.sendUpdate(updatedJson, state);
  //   // if (this.autoSaveTimer) {
  //   //   clearTimeout(this.autoSaveTimer);
  //   // }

  //   // // debounce after 3 sec after json updates (From Stepper form component)
  //   // this.autoSaveTimer = setTimeout(() => {
  //   //   console.log("Auto-saving after change...");
  //   //   this.sendUpdate(updatedJson, state);
  //   // }, 3000); // <-- 3 sec after last change
  // }

  loadCommentsForStrategy(strategyId: any): void {
    this.jsignalsService.getComments(strategyId).subscribe({
      next: (res: any) => {
        // Save all comments JSON into allComments[] then pass to comments component
        this.allComments = res;
        // console.log("Comments loaded for strategy:", strategyId, res.length);
      },
      error: (err) => {
        this.snackBar.open("Failed to load comments", "OK", { duration: 3000 });
        console.error(err);
      },
    });
  }

  fetchLatestJson(): void {
    //The below condition prevents api call for the selected strategy id after cancel
    if (this.productStrategyIdToEdit == null) {
      return;
    }
    this.spinner.start();
    console.log("inside fetchLatestJson");

    this.jsignalsService
      .getProductStrategyById(this.productStrategyIdToEdit)
      .subscribe({
        next: async (res: any) => {
          // Always clone to force Angular change detection
          // this.ProductStrategyJson = JSON.parse(res.productstrategyJson);
          try {
            // Safely parse JSON
              this.ProductStrategyJson = JSON.parse(res.productstrategyJson);
              console.log("Parsed ProductStrategyJson:", this.ProductStrategyJson);
          } catch (parseError) {
              console.error("Invalid JSON in response:", parseError, res.productstrategyJson);
              this.snackBar.open(`Invalid Json - ${parseError}`, "Ok", {
              duration: 4000,
            });
            // Cancel Edit If Any Error Occured 
            this.onEditCancel();
            return; // stop further processing
          }
          console.log(this.ProductStrategyJson);
          //Setting Original-Hash
          this.originalHash =  await this.jsignalsService.getJsonHash(this.ProductStrategyJson);
          console.log("Original hash set:", this.originalHash);
          this.spinner.stop();
        },
        error: (err) => {
          console.error("Failed to fetch latest JSON", err);
          this.snackBar.open(err.error.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
        },
      });
  }
  // Check if JSON has changed
  async hasChanged(): Promise<boolean> {
    if (!this.originalHash) return true;
    const currentHash = await this.jsignalsService.getJsonHash(this.currentData);
    return this.originalHash !== currentHash;
  }
   // Fetches the User Roles
Useroles(): void {
    
  const dnsid = this.localStorage.getSettings("dnsName");
  if(dnsid){
    //this.service.
    this.service.getUserRoles(this.localStorage.getSettings("dnsName"))
    .subscribe(
      (response) => {
        this.Accesstypes = response; // Assign fetched user roles to the types array
        console.log(this.Accesstypes);
      },
      (error) => {
        console.error('Error fetching user roles:', error);
      }
    );
    }
  }
  compareSelectedStrategies(){
    console.log("inside compare")
  }
  downloadSelectedStrategies(){
    console.log("Inside bulk download of strategies")
  }

  /**
   * @Author Rahul Vk
   * @Date 14-11-2025
   * @Desc Selecting Scheduler for the creation of PSS After closing dialog retrieving scheduleid and schedule desc
   */   
    selectSchedulerClick() {
  
      let obj =  {
      customreportmstrid:this.getUniqueNumber()
      }
      let dialogRef = this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: "80%",
        autoFocus: false,
  
        data: { edata: obj,scheduleFor:'pss_doc_Schedule'},
  
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe(obj => {
        console.log("obj: ",obj);
        this.scheduleid = obj.scheduleid
        this.selectSchedule = obj.scheduleDesc
        console.log("scheduledesc",this.selectSchedule);
        console.log("scheduleid",this.scheduleid);
      });
    }

    /**
   * @Author Rahul Vk
   * @Date 14-11-2025
   * @Desc generates uniques 4 digit number 
   */   
    generateUniqueId(): number {
      return Math.floor(1000 + Math.random() * 9000); // always 4 digits
    }

    async deleteSchedule() {
      if(this.scheduleid != null){
        await this.secheduleService.deleteDispatchHistory(this.scheduleid);
      }
    }

  /**
   * @Author Rahul Vk
   * @Date 14-11-2025
   * @Desc if the uniquenumberForPssScheduler is present inlocalstorage fetchs from their or creates new number 
   */ 
  getUniqueNumber(){
    const storedValue = this.localStorage.getSettings('uniquenumberForPssScheduler');
    if(storedValue == null){
    // generate new unique number
    this.uniquenumber = this.generateUniqueId();
    // store it as string (localStorage only stores strings)
    localStorage.setItem('uniquenumberForPssScheduler', this.uniquenumber.toString());
    } else {
    // convert back to number
    this.uniquenumber = Number(storedValue);
  }
    return this.uniquenumber
  }

  get visibleProducts() {
  return this.selectedProductsFromDialog?.slice(0, this.maxVisibleChips) || [];
  }

  get hiddenCount() {
    return Math.max(0, this.selectedProductsFromDialog?.length - this.maxVisibleChips);
  }
  get allProductsTooltip() {
  return this.selectedProductsFromDialog?.join(', ');
  }

  getProductInfoPage({event, rowData}: any){
    console.log(rowData);
    console.log("Selected Product Id : ",rowData.productId);
    this.selectedProductIdFromGridToShowInfo=rowData.productId;
    this.showProductInfoPage=true;
  }
  hiddeProductInfoPage(){
     this.showProductInfoPage=false;
  }

  onRegenerateDocument({ event, rowData }: any) {

    if (rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    if(rowData.wordDocGenerationStatus ===  "In Progress"){
      this.snackBar.open("Document Generation is in Progress. Please try again Later", "OK", { duration: 3000 });
      return;
    }
  
    if (rowData.state !==  "Approved") {
      this.snackBar.open("Only approved documents can be regenerated.", "OK", { duration: 3000 });
      return;
    }
   
    let strategyId = rowData?.id;
     console.log("Regenerate document id:", strategyId);
    this.spinner.start();
    this.jsignalsService.regenerateWordDocument(strategyId).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.loadGridData(); 
          this.spinner.stop();
          return;
        }
        this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.loadGridData(); // Refresh the grid to show updated document status
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching study registrations:", error);
        this.snackBar.open(error.statusMessage, "Close", {
            duration: 3000,
          });
          this.loadGridData(); 
        this.spinner.stop();
      },
    });
  }

processResponseData(responseData: any[]): any[] {  // Add return type
  return responseData.map((row) => {
    console.log("👉 Raw row:", row);

    // 1) Grab the JSON string from whichever field
    const rawJson = row.productstrategyJson ?? row.productStrategyJson;
    
    // 2) First parse
    let parsed: any;
    try {
      parsed = JSON.parse(rawJson);
      console.log("   After JSON.parse:", parsed);
    } catch (e) {
      console.error("JSON.parse failed:", e, rawJson);
      parsed = rawJson;
    }

    // 3) If it’s still a string, parse again
    if (typeof parsed === "string") {
      try {
        parsed = JSON.parse(parsed);
        console.log("   After second parse:", parsed);
      } catch (e) {
        console.error(" second JSON.parse failed:", e, parsed);
      }
    }

    // 4) If it’s an array, unwrap to the first element
    if (Array.isArray(parsed)) {
      console.log("   Parsed is an array, unwrapping first element:", parsed[0]);
      parsed = parsed[0];
    }

    // 5) Now we expect an object with a `sections` array
    console.log("   Final strategy object:", parsed);
    console.log("   Sections array:", parsed.sections);

    // 6) Find the Activity Details section
    const activitySection = (parsed.sections || []).find(
      (s: any) => s["Section Title"] === "Activity Details"
    );
    console.log("   Found activitySection:", activitySection);

    // 7) Extract and join activity names
    let activityNames = "";
    if (activitySection && Array.isArray(activitySection.activity)) {
      activityNames = activitySection.activity
        .map((item: any) => item.activity)
        .filter((a: any) => typeof a === "string")
        .join(", ");
    }
    console.log("   Computed activityNames:", activityNames);

    return {
      ...row,
      activityname: activityNames,
    };
  });
}


}